export function onPopState(fn: (e: PopStateEvent) => void) {
    // force function invocation to end of browser's event queue for most recent data using setTimeout()
    const callback = (e: PopStateEvent) => window.setTimeout(() => fn(e), 0);
    window.addEventListener('popstate', callback);

    return {
        unsubscribe: () => window.removeEventListener('popstate', callback),
    };
}
